
import isReachable from 'is-reachable';

import CheckIP from './Check-IP';
//import isOnline from 'is-online';


export default async function CheckVPN(): Promise<boolean> {
    console.log("Ejecutando CheckVPN");

    let Resultado: boolean = true;

    //let host = 'https://jenkins.starken.cl';

    let host = 'jenkins.starken.cl';

    try {

        Resultado = await isReachable(host);

    } catch (error) {
        console.error("Error en CheckVPN:", error);
        Resultado = false;
    }

    console.log("Resultado: " + Resultado);


    return Resultado;
}